module.exports = __webpack_public_path__ + "img/img-box-services-landing-page-right.11c220ff.png";